export default {
  "content": "<path clip-rule=\"evenodd\" d=\"M8 16A8 8 0 108 0a8 8 0 000 16zM5 7a1 1 0 000 2h6a1 1 0 100-2z\" fill=\"#ff00cb\" fill-rule=\"evenodd\"/>",
  "attrs": {
    "viewBox": "0 0 16 16",
    "fill": "none",
    "height": "16",
    "width": "16",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};